var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cs-simple-search"},[_c('div',{staticClass:"cs-simple-search-content"},[_vm._t("default")],2),_c('el-button',{staticClass:"cs-simple-search-refresh",attrs:{"icon":"el-icon-refresh"},on:{"click":_vm.refresh}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }